import React from "react";

import {SvgIcon, SvgIconProps} from "@mui/material";

export default function MessageCheckIcon(props: SvgIconProps) {
	return (
		<SvgIcon {...props}>
			<path d="M20,2 C21.1,2 22,2.89 22,4 L22,4 L22,16 C22,17.1045695 21.1045695,18 20,18 L20,18 L6,18 L2,22 L2,4 C2,2.8954305 2.8954305,2 4,2 L4,2 Z M16.59,5.58 L10,12.17 L7.41,9.59 L6,11 L10,15 L18,7 L16.59,5.58 Z" />
		</SvgIcon>
	);
}